import React, { Component } from "react";
import {
  Progress,
  Tag,
  Select,
  Input,
  Checkbox,
} from "antd";
import Api from "../../../ServiceApi";
const { Option } = Select;
const statusList = [
  "Claim",
  "Monitoring",
  "Cleaning",
  "Checking",
  "Photo",
  "Aqm",
  "Extra/Special",
  "Claim Supplier",
  "System Engineer",
];
// const menu = (
//   <Menu>
//     <Menu.Item>
//       <Checkbox>User1</Checkbox>
//     </Menu.Item>
//     <Menu.Item>
//       <Checkbox>User2</Checkbox>
//     </Menu.Item>
//   </Menu>
// );
// const options = [
//   { label: "Claim", value: "Claim" },
//   { label: "Monitoring", value: "Monitoring" },
//   { label: "Cleaning", value: "Cleaning" },
//   { label: "Checking", value: "Checking" },
//   { label: "Photo", value: "Photo" },
//   { label: "Aqm", value: "Aqm" },
//   { label: "Extra/Special", value: "extra" },
//   { label: "Claim Supplier", value: "supplier" },
//   { label: "System Engineer", value: "systemEngineer" },
// ];
const priorityList = ["High", "Normal", "Low"];
const teamList = ["A", "B", "C", "D"];
class ProgressTask extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value_filter: "",
    };
  }
  onChangeJobCategory = (e) => {
    console.log("job cat", e);
  };
  handleJobIDChange = (e) => {
    console.log("value from search", e.target.value);
    let currentList = [];
    let newList = [];
    this.setState({ value_filter: e.target.value });
    if (e.target.value !== "") {
      currentList = this.props.data;
      newList = currentList.filter((item) => {
        return item.job_id.toLowerCase().includes(e.target.value.toLowerCase());
      });
    } else {
      newList = this.props.data;
    }
    this.props.data = newList;
  };
  render() {
    const { data } = this.props;
    const { value_filter } = this.state;
    return (
      <div style={{ padding: "20px" }}>
        <div className="row mb-4">
          <div className="col-10">
            {/* statusList  */}
            <Select
              value="Job Category"
              placeholder="Job Category"
              style={{ width: "140px", "margin-right": "1rem" }}
              onChange={this.onChangeJobCategory}
              // mode="multiple"
              // allowClear
            >
              Job Category
              {statusList.map((item, index) => (
                <Option value={item}>
                  {/* <Menu.Item key={index}> */}
                  <Checkbox key={index}>{item}</Checkbox>
                  {/* </Menu.Item> */}
                </Option>
              ))}
            </Select>
            {/* <Dropdown
              style={{ width: "140px", "margin-right": "1rem" }}
              overlay={menu}
              // onChange={this.onChangeasset}
            >
            <Button>
            <span>Job Category</span> <DownOutlined />
            </Button>
            </Dropdown> */}
            {/* Priority List */}
            <Select
              placeholder="Priority"
              style={{ width: "140px", "margin-right": "1rem" }}
              onChange={this.onChangeasset}
            >
              {priorityList.map((item, index) => (
                <Option value={item} type_sc="priority">
                  {item}
                </Option>
              ))}
            </Select>
            {/* Team List */}
            <Select
              placeholder="Team"
              style={{ width: "140px", "margin-right": "1rem" }}
              onChange={this.onChangeasset}
            >
              {teamList.map((item, index) => (
                <Option value={item} type_sc="team">
                  {item}
                </Option>
              ))}
            </Select>
            {/* Search box */}
            <Input
              placeholder="Job ID"
              value={value_filter}
              style={{ width: 300 }}
              suffix={<img src={Api.absoluteUrl("/icon/search.svg")} alt="" />}
              onChange={this.handleJobIDChange}
            />
          </div>
          <div className="col-2">
            <div className="fs-30 font-thai-b mb-0 text-uppercase">
              27 june 2020
            </div>
          </div>
        </div>
        <div className="row mb-4">
          <div className="col-12">
            <ul className="tag-skill">
              <li>Claim</li>
              <li>Cleaning</li>
              <li>Monitoring</li>
              <li>Photo</li>
            </ul>
          </div>
        </div>
        <div className="row">
          <div className="col pr-0">
            <div className="card-task-team">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h4 className="fs-14 c-blue font-mont-b mb-0 text-uppercase">
                  Ack Job
                </h4>
                <button>
                  {/* three dots */}
                  {/* <svg
                    className="bi bi-three-dots"
                    width="1em"
                    height="1em"
                    viewBox="0 0 16 16"
                    fill="currentColor"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      d="M3 9.5a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm5 0a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm5 0a1.5 1.5 0 110-3 1.5 1.5 0 010 3z"
                      clipRule="evenodd"
                    />
                  </svg> */}
                </button>
              </div>
              {data.map((item, index) => (
                <div key={index} className="item">
                  <a href="/MaxiOperation/full_detail_job">
                    <div className="d-flex justify-content-between align-items-center">
                      <Tag
                        color="#e8cd00"
                        style={{
                          "border-radius": "50px",
                          padding: "0 15px",
                          color: "#000f9f",
                        }}
                      >
                        Normal
                      </Tag>
                      <span className="font-thai-r fs-16">27 Apr 2018</span>
                    </div>
                    <div className="c-blue font-thai-b fs-18">
                      410000096645
                      <br />
                      แยกวิทยุ (สะพานไทย-เบลเยียม)
                    </div>
                    <Progress percent={25} showInfo={false} />
                    <div className="d-flex justify-content-between align-items-center">
                      <span className="font-thai-b text-uppercase c-black fs-16">
                        Team01
                      </span>
                      <div>
                        <img
                          src={Api.absoluteUrl("/img/user1.png")}
                          width="20"
                          alt=""
                        />
                        <img
                          src={Api.absoluteUrl("/img/user1.png")}
                          width="20"
                          alt=""
                        />
                        <img
                          src={Api.absoluteUrl("/img/user1.png")}
                          width="20"
                          alt=""
                        />
                        <img
                          src={Api.absoluteUrl("/img/user1.png")}
                          width="20"
                          alt=""
                        />
                      </div>
                    </div>
                  </a>
                </div>
              ))}
            </div>
          </div>
          <div className="col pr-0">
            <div className="card-task-team">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h4 className="fs-14 c-blue font-mont-b mb-0 text-uppercase">
                  On process
                </h4>
                {/* <a>
                  <svg
                    className="bi bi-three-dots"
                    width="1em"
                    height="1em"
                    viewBox="0 0 16 16"
                    fill="currentColor"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      d="M3 9.5a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm5 0a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm5 0a1.5 1.5 0 110-3 1.5 1.5 0 010 3z"
                      clipRule="evenodd"
                    />
                  </svg>
                </a> */}
              </div>
              {data.map((item, index) => (
                <div key={index} className="item">
                  <a href="/MaxiOperation/full_detail_job">
                    <div className="d-flex justify-content-between align-items-center">
                      <Tag
                        color="green"
                        style={{ "border-radius": "50px", padding: "0 15px" }}
                      >
                        Low
                      </Tag>
                      <span className="font-thai-r fs-16">27 Apr 2018</span>
                    </div>
                    <div className="c-blue font-thai-b fs-18">
                      410000097732
                      <br />
                      แยกอโศกตัดสุขุมวิท
                    </div>
                    <Progress percent={50} showInfo={false} />
                    <div className="d-flex justify-content-between align-items-center">
                      <span className="font-thai-b text-uppercase c-black fs-16">
                        Team01
                      </span>
                      <div>
                        <img
                          src={Api.absoluteUrl("/img/user1.png")}
                          width="20"
                          alt=""
                        />
                        <img
                          src={Api.absoluteUrl("/img/user1.png")}
                          width="20"
                          alt=""
                        />
                        <img
                          src={Api.absoluteUrl("/img/user1.png")}
                          width="20"
                          alt=""
                        />
                        <img
                          src={Api.absoluteUrl("/img/user1.png")}
                          width="20"
                          alt=""
                        />
                      </div>
                    </div>
                  </a>
                </div>
              ))}
            </div>
          </div>
          <div className="col pr-0">
            <div className="card-task-team">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h4 className="fs-14 c-blue font-mont-b mb-0 text-uppercase">
                  Finished
                </h4>
                {/* <a>
                  <svg
                    className="bi bi-three-dots"
                    width="1em"
                    height="1em"
                    viewBox="0 0 16 16"
                    fill="currentColor"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      d="M3 9.5a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm5 0a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm5 0a1.5 1.5 0 110-3 1.5 1.5 0 010 3z"
                      clipRule="evenodd"
                    />
                  </svg>
                </a> */}
              </div>
              {data.map((item, index) => (
                <div key={index} className="item">
                  <a href="/MaxiOperation/full_detail_job">
                    <div className="d-flex justify-content-between align-items-center">
                      <Tag
                        color="green"
                        style={{ "border-radius": "50px", padding: "0 15px" }}
                      >
                        Low
                      </Tag>
                      <span className="font-thai-r fs-16">27 Apr 2018</span>
                    </div>
                    <div className="c-blue font-thai-b fs-18">
                      41000006812
                      <br />
                      ลานน้ำพุ สยามพารากอน
                    </div>
                    <Progress percent={75} showInfo={false} />
                    <div className="d-flex justify-content-between align-items-center">
                      <span className="font-thai-b text-uppercase c-black fs-16">
                        Team01
                      </span>
                      <div>
                        <img
                          src={Api.absoluteUrl("/img/user1.png")}
                          width="20"
                          alt=""
                        />
                        <img
                          src={Api.absoluteUrl("/img/user1.png")}
                          width="20"
                          alt=""
                        />
                        <img
                          src={Api.absoluteUrl("/img/user1.png")}
                          width="20"
                          alt=""
                        />
                        <img
                          src={Api.absoluteUrl("/img/user1.png")}
                          width="20"
                          alt=""
                        />
                      </div>
                    </div>
                  </a>
                </div>
              ))}
            </div>
          </div>
          <div className="col pr-0">
            <div className="card-task-team">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h4 className="fs-14 c-blue font-mont-b mb-0 text-uppercase">
                  TL Approve
                </h4>
                {/* <a>
                  <svg
                    className="bi bi-three-dots"
                    width="1em"
                    height="1em"
                    viewBox="0 0 16 16"
                    fill="currentColor"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      d="M3 9.5a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm5 0a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm5 0a1.5 1.5 0 110-3 1.5 1.5 0 010 3z"
                      clipRule="evenodd"
                    />
                  </svg>
                </a> */}
              </div>
              {data.map((item, index) => (
                <div key={index} className="item">
                  <a href="/MaxiOperation/full_detail_job">
                    <div className="d-flex  align-items-center">
                      <Tag
                        color="#e09307"
                        style={{
                          "border-radius": "50px",
                          padding: "0 15px",
                          color: "white",
                        }}
                      >
                        High
                      </Tag>
                      <Tag
                        style={{
                          "border-radius": "50px",
                          padding: "0 15px",
                          "border-color": "rgb(166, 167, 185)",
                          "font-color": "rgb(166, 167, 185)",
                        }}
                      >
                        Extra/Special
                      </Tag>
                      <span
                        style={{ float: "right" }}
                        className="font-thai-r fs-16"
                      >
                        27 Apr 2018
                      </span>
                    </div>
                    <div className="c-blue font-thai-b fs-18">
                      410000099975
                      <br />
                      ลานน้ำพุ สยามพารากอน
                    </div>
                    <Progress percent={100} showInfo={false} />
                    <div className="d-flex justify-content-between align-items-center">
                      <span className="font-thai-b text-uppercase c-black fs-16">
                        Team01
                      </span>
                      <div>
                        <img
                          src={Api.absoluteUrl("/img/user1.png")}
                          width="20"
                          alt=""
                        />
                        <img
                          src={Api.absoluteUrl("/img/user1.png")}
                          width="20"
                          alt=""
                        />
                        <img
                          src={Api.absoluteUrl("/img/user1.png")}
                          width="20"
                          alt=""
                        />
                        <img
                          src={Api.absoluteUrl("/img/user1.png")}
                          width="20"
                          alt=""
                        />
                      </div>
                    </div>
                  </a>
                </div>
              ))}
            </div>
          </div>
          {/* <div className="col">
                        <div className="card-task-team">
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <h4 className="fs-14 c-blue font-mont-b mb-0 text-uppercase">Completed</h4>
                                <a>
                                    <svg className="bi bi-three-dots" width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                        <path fillRule="evenodd" d="M3 9.5a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm5 0a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm5 0a1.5 1.5 0 110-3 1.5 1.5 0 010 3z" clipRule="evenodd" />
                                    </svg>
                                </a>
                            </div>
                            {data.map((item, index)=><div key={index} className="item">
                                <a href="/MaxiOperation/full_detail/full_detail_job">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <Tag color="green">Cleaning</Tag>
                                        <span className="font-thai-r fs-16">27 Apr 2018</span>
                                    </div>
                                    <div className="c-blue font-thai-b fs-18">DGT-PARC<br/>ลานน้ำพุ สยามพารากอน</div>
                                    <Progress percent={100} showInfo={false} />
                                    <div className="d-flex justify-content-between align-items-center">
                                        <span className="font-thai-b text-uppercase c-black fs-16">Team01</span>
                                        <div>
                                             <img src={Api.absoluteUrl("/img/user1.png")} width="20" alt="" />
                        <img src={Api.absoluteUrl("/img/user1.png")} width="20" alt="" />
                        <img src={Api.absoluteUrl("/img/user1.png")} width="20" alt="" />
                        <img src={Api.absoluteUrl("/img/user1.png")} width="20" alt="" />
                                        </div>
                                    </div>
                                </a>
                            </div>)}
                        </div>
                    </div> */}
        </div>
      </div>
    );
  }
}

export default ProgressTask;
